import InFocusNotification from './InFocusNotification';
import OutOfFocusNotification from './OutOfFocusNotification/OutOfFocusNotification';
import useNavigationNotification from './vm';

const NavigationNotification = () => {
  const { isPresenting, isInFocus } = useNavigationNotification();

  if (!isPresenting) return null;

  if (isInFocus) {
    return <InFocusNotification />;
  }

  return <OutOfFocusNotification />;
};

export default NavigationNotification;
